import axios from "axios";
import { IAxiosReturn } from "../interface";
import { processAxiosError } from "../processAxiosError";
import { ClinicalLibraryReadDto } from "./interface";

export type ClinicalLibrariesReadDtoReturn = IAxiosReturn<ClinicalLibraryReadDto[]>;

/**
 * Fetch a collection of clinical libraries for multiple hierarchy IDs in a single backend request.
 *
 * @param backEndUrl - Backend base URL
 * @param hierarchyIds - Array of hierarchy IDs to fetch libraries for
 * @param controller - Optional AbortController
 * @returns Promise<ClinicalLibrariesReadDtoReturn>
 */
export const getLibraries = async (
  backEndUrl: string,
  hierarchyIds: string[],
  controller: AbortController,
): Promise<ClinicalLibrariesReadDtoReturn> => {
  const url = new URL(`${backEndUrl}ClinicalLibrary/batch`);
  try {
    hierarchyIds.forEach((hierarchyId) => {
      url.searchParams.append("hierarchyIds", hierarchyId);
    });
    const response = await axios.get(url.href, {
      signal: controller?.signal,
    });
    return { success: true, data: response.data };
  } catch (error: unknown) {
    return processAxiosError("get libraries failed", error);
  }
};
